<template>
  <form @submit.prevent="submit">
    <div class="modal fade" id="expert-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <template v-if="!resp">
          <div class="modal-content">
            <div class="modal-header">
              <div class="title-with-icon">
                <div class="title-with-icon__icon title-with-icon__icon_partner"></div>
                <div class="title-with-icon__title">Заявка на участие в «Экспортном разборе»</div>
              </div>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="form-item">
                <label><b>Фамилия</b></label>
                <input v-model="data.lastname" class="form-control" required />
              </div>
              <div class="form-item">
                <label><b>Имя</b></label>
                <input v-model="data.firstname" class="form-control" required />
              </div>
              <div class="form-item">
                <label><b>Отчество</b></label>
                <input v-model="data.middlename" class="form-control" />
              </div>
              <div class="form-item">
                <label><b>Должность</b></label>
                <input v-model="data.position" class="form-control" required />
              </div>
              <div class="form-item">
                <label><b>Телефон</b></label>
                <input v-model="data.phone" v-imask="{mask: '+{7} (000) 000-0000'}" :class="{'is-invalid': isError}" class="form-control" required />
                <div class="invalid-feedback">Проверьте правильность ввода номера</div>
              </div>
              <div class="form-item">
                <label><b>Email</b></label>
                <input v-model="data.email" type="email" class="form-control" required />
              </div>
            </div>

            <div class="modal-footer flex-column align-items-start">
              <div class="checkbox-wrapper mb-2">
                <div class="checkbox">
                  <input v-model="checked" type="checkbox" id="register-conditions" />
                  <label for="register-conditions">
                    Я согласен(на) с условиями
                  </label>
                  <a href="//exporteduru.servicecdn.ru/media/default/0003/43/3833f8c292fd7e1ebf9800122610962ae551ac58.pdf" target="_blank" class="ml-1">публичной оферты</a>
                  <span>и</span>
                  <a href="https://exporteduru.servicecdn.ru/media/default/0003/12/afe4c45ca00400534ab0ec8b7cc4189169882841.pdf" target="_blank">политикой обработки персональных данных</a>
                </div>
              </div>
              <div class="consent-text text-muted small">
                <p>1. Настоящим я даю согласие на обработку следующих персональных данных:</p>
                <ul>
                  <li>Фамилия, Имя, Отчество</li>
                  <li>Должность</li>
                  <li>Контактные данные (телефон, e-mail)</li>
                </ul>
                <p>с целью получения услуги «Экспортный разбор», предоставляемой АНО ДПО "Школа экспорта Акционерного общества "Российский экспортный центр".</p>
                <p>2. Персональные данные обрабатываются АНО ДПО "Школа экспорта Акционерного общества "Российский экспортный центр" до окончания реализации услуги «Экспортный разбор» и подписания акта оказанных услуг.</p>
              </div>

              <button :disabled="!checked" type="submit" class="btn btn-primary mt-3">Отправить заявку</button>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="modal-content form-result">
            <div class="modal-body d-flex justify-content-between align-items-center">
              <div>
                <h2>Спасибо!</h2>
                <p class="text-16">Ваша заявка принята в работу!</p>
              </div>
              <button @click="toProfile" type="button" class="btn btn-primary btn-lg btn-rounded mb-0">OK</button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </form>
</template>

<script>
import { IMaskDirective } from 'vue-imask';
import ApiService from "../../../services/api.service";
import $ from "jquery";

export default {
  name: "ModalExpert",
  directives: { imask: IMaskDirective },
  data() {
    return {
      data: {
        lastname: '',
        firstname: '',
        middlename: '',
        position: '',
        phone: '',
        email: ''
      },
      checked: false,
      isError: false,
      resp: null
    }
  },
  methods: {
    toProfile() {
      window.location.href = '/lk/settings/personal';
    },
    async submit() {
      if (!this.data.phone || this.data.phone.length < 16) {
        this.isError = true;
        return;
      }

      try {
        const payload = { ...this.data };
        const resp = await ApiService.post('export-review-order', payload);
        if (resp.status === 201) {
          this.resp = resp.data;
          console.log('this.isError = false;')
        } else {
          console.log('this.isError = true;')
        }
        await this.$toastr.s('', 'Заявка успешно отправлена')
      } catch (e) {
        await this.$toastr.e('', 'Проверьте заполнение полей')
        console.log('this.isError = true;')
      } finally {
        $('#expert-modal').modal('hide');
      }
    }
  }
}
</script>

<style scoped>
.consent-text {
  font-size: 12px;
  line-height: 1.4;
}
.checkbox-wrapper .checkbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
}
.checkbox-wrapper input {
  width: auto;
}
.checkbox-wrapper a {
  color: #ED1B2F;
}
.checkbox-wrapper a, .checkbox-wrapper span {
  font-size: 1.8rem;
  line-height: 1.35;
  margin-bottom: 1.2rem;
}
</style>